import Vue from "vue";
import VueRouter from "vue-router";
import Red from "@/views/Red.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Red",
    component: Red,
  },
  {
    path: "/mapa",
    name: "Mapa",
    component: () => import("../views/Mapa.vue"),
  },
  {
    path: "/estadisticas",
    name: "Estadisticas",
    component: () => import("../views/Estadisticas.vue"),
  },
  {
    path: "/contexto",
    name: "Contexto",
    component: () => import("../views/Contexto.vue"),
  },
  {
    path: "/metodologia",
    name: "Metodologia",
    component: () => import("../views/Metodologia.vue"),
  },
  {
    path: "/definiciones",
    name: "Definiciones",
    component: () => import("../views/Definiciones.vue"),
  },
  {
    path: "/creditos",
    name: "Creditos",
    component: () => import("../views/Creditos.vue"),
  },
  {
    path: "/creditos/:id",
    name: "Investigadores",
    component: () => import("../views/DetalleInvestigadorxs.vue"),
    props: true,
  },
  {
    path: "/datos",
    name: "datos",
    component: () => import("../views/Datos.vue"),
  },
  {
    path: "/vigilancia",
    name: "Vigilancia",
    component: () => import("../views/Vigilancia.vue"),
  },
  {
    path: "**",
    name: "Err404",
    component: () => import("../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0, behavior: "smooth" };
  },
});

export default router;
